import { IRevenueSpendByAccountOfferSpendDetailsTableLang } from '../../../types/lang'

export const revenueSpendByAccountOfferSpendDetailsTableLang: IRevenueSpendByAccountOfferSpendDetailsTableLang = {
	revenue_spend_by_account_offer_spend_details_table: {
		column_id: 'ID',
		column_date: 'Date',
		column_amount: 'Amount',
		column_percent: 'Percent, %',
		column_offer: 'Offer',
		column_scope: 'Scope',
		column_notes: 'Notes'
	}
}